'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _utils = require('../../../utils');

var _mightyFields = require('../../../lib/mighty-fields');

var _commonFormsy = require('../../common-formsy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;
var NewCaseModalSearch = (_dec = (0, _mobxReact.inject)('OptionsStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(NewCaseModalSearch, _Component);

  function NewCaseModalSearch() {
    _classCallCheck(this, NewCaseModalSearch);

    return _possibleConstructorReturn(this, (NewCaseModalSearch.__proto__ || Object.getPrototypeOf(NewCaseModalSearch)).apply(this, arguments));
  }

  _createClass(NewCaseModalSearch, [{
    key: 'renderDropdownItem',
    value: function renderDropdownItem(_case) {
      var OptionsStore = this.props.OptionsStore;


      return _react2.default.createElement(
        'span',
        { className: 'plaintiff-item' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            { className: 'fs-mask' },
            getNameOrDefault(_case.plaintiff)
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          OptionsStore.getCaseTypeOptionById(_case.type).name,
          ', ',
          getNameOrDefault(_case.lawfirm)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          addNew = _props.addNew,
          redirectToCase = _props.redirectToCase,
          PLAINTIFF_SEARCH_FIELD_SETS = [[{
        addNewSearchMinimum: 3,
        className: 'fs-mask',
        endpoint: '/case-search/',
        field: 'plaintiff',
        render: this.renderDropdownItem,
        type: 'objectSearchCreate'
      }]];


      return _react2.default.createElement(
        _commonFormsy.Form,
        null,
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          _react2.default.createElement(_mightyFields.FormFieldSets, {
            addNew: addNew,
            fieldSets: PLAINTIFF_SEARCH_FIELD_SETS,
            onChange: { plaintiff: redirectToCase }
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return NewCaseModalSearch;
}(_react.Component), _class2.propTypes = {
  addNew: _propTypes2.default.func.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  redirectToCase: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = NewCaseModalSearch;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/layout/modal-new-case/NewCaseModalSearch.js');
  reactHotLoader.register(NewCaseModalSearch, 'NewCaseModalSearch', '/app/src/components/layout/modal-new-case/NewCaseModalSearch.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/layout/modal-new-case/NewCaseModalSearch.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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